import { EffectCallback, MutableRefObject, useEffect, useRef } from 'react'

/**
 * Use setTimeout with Hooks in a declarative way.
 *
 * @see https://stackoverflow.com/a/59274757/3723993
 * @see https://overreacted.io/making-setinterval-declarative-with-react-hooks/
 */
export default function useTimeout(
  callback: EffectCallback,
  delay: number | null,
): MutableRefObject<number | null> {
  const timeoutRef = useRef<number | null>(null)
  const callbackRef = useRef(callback)

  useEffect(() => {
    callbackRef.current = callback
  }, [callback])

  useEffect(() => {
    if (typeof delay === 'number') {
      timeoutRef.current = window.setTimeout(() => callbackRef.current(), delay)

      return () => window.clearTimeout(timeoutRef.current || 0)
    }
  }, [delay])

  // In case you want to manually clear the timeout from the consuming component
  return timeoutRef
}
